import { Mock } from "../lib/appfuse-react/core/ajax";
import salesService from "../mock/sales";
import iamService from "../mock/iam";
import contentService from "../mock/content";
import institutionService from "../mock/institution";
import caseInfoService from "../mock/caseInfo";
import collectionDateService from "../mock/collectionDate";
import testDateService from "../mock/testDate";
import testReportService from "../mock/testReport";
import noReportService from "../mock/noReport";
import positiveReportService from "../mock/positiveReport";
import accountService from "../mock/account";

const mock = (function() {
    const mock = new Mock();
    mock.use(iamService);
    mock.use(contentService);
    mock.use(salesService);
    mock.use(institutionService);
    mock.use(caseInfoService);
    mock.use(collectionDateService);
    mock.use(testDateService);
    mock.use(testReportService);
    mock.use(noReportService);
    mock.use(positiveReportService);
    mock.use(accountService);
    return mock;
}());

const context = {mock};

export default context;

export {mock};